import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { PublicAuthToken } from '@api/shared-types/PublicAuthToken';
import { LoginObject } from '@api/shared-types/LoginObject';



export const authApi = createApi({
	reducerPath: 'authApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.AUTH_SERVER_URL}/`,
	}),
	endpoints: (builder) => ({

		login: builder.mutation<PublicAuthToken,Omit<LoginObject, 'app'>>({
			query: ({ username, password }) => ({
				url: 'User/Login',
				method: 'POST',
				body: { username, password, app: process.env.AUTH_APP }
			}),
		}),

	}),
});


export const {
	useLoginMutation } = authApi;